<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros style="width: 400px;"
    [name]="'filtros.per' | translate"
    [array]="anios"
    [typeFilter]="Filters.YEAR"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>

  <div contenido class="contenido">
    @if(ganttRows.length !== 0){
      <app-gantt
        [data]="ganttRows"
        [year]="cadenaEvaluacion.name"
        (eventoBotonHeader)="eventosHeaders($event)"
        (eventoBotonFuncionalidades)="eventosTablas($event)"
      />
    }
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal1" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-proyecto' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-proyecto' | translate}}</span>
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formProy">

      <div class="form-group">
        <label for="pregunta" class="form-label">
            {{'cues.proyectos.selec-preg' | translate}} *
        </label>
        <select id="pregunta" class="contentSelect anchosInputs" formControlName="relacionId" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of indicadores; track $index) {
            <option class="textoOverFlow" value="{{elem.id}}" title="{{elem.descripcion}}">
              {{elem.name}}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="nombre" class="form-label">
            {{'cues.proyectos.nombre' | translate}} *
        </label>
        <input type="text" id="nombre" class="form-input anchosInputs" formControlName="name" required>
      </div>

      <div class="form-group">
        <label for="responsible" class="form-label">
            {{'cues.proyectos.selec-responsible' | translate}}
        </label>
        <select id="responsible" class="contentSelect anchosInputs" formControlName="responsible" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of responsibles; track elem.element) {
            <option [value]="elem.id"> {{elem.roleName}} </option>
          }
        </select>
      </div>

      </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formProy.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationProyects()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modal2" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-actividad' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-actividad' | translate}}</span>
    }
  </div>
  
  <div modal-body>
    <div class="w3-row" [formGroup]="formActi">
      <div class="form-group">
        <label for="nombre" class="form-label">
            {{'cues.proyectos.nombre-actividad' | translate}} *
        </label>
        <input type="text" id="nombre" class="form-input anchosInputs" formControlName="name" required>
      </div>

      <div class="form-group">
        <label for="responsible" class="form-label">
            {{'cues.proyectos.selec-responsible' | translate}}
        </label>
        <select id="responsible" class="contentSelect anchosInputs" formControlName="responsible" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of responsibles; track elem.element) {
            <option [value]="elem.id"> {{elem.roleName}} </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="fechaIni" class="form-label"> {{'cues.proyectos.fecha-inicio' | translate}} *</label>
        <input id="fechaIni" type="date" class="form-input anchosInputs" formControlName="startDate">
      </div>

      <div class="form-group">
        <label for="fechaFin" class="form-label"> {{'cues.proyectos.fecha-inicio' | translate}} *</label>
        <input id="fechaFin" type="date" class="form-input anchosInputs" formControlName="endDate"  min="{{formActi.controls['startDate'].value}}">
      </div>

    </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formActi.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationActivities()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modal3" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-actividad' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-actividad' | translate}}</span>
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formAdit">

      @if(formAdit.hasError('isValid')){
        <div class="alinLeft w3-row"  style="font-size: 8pt; color: red">{{'gestion.formulacion.alta-actas.nombreExis'|translate}}</div>
      } 
      <div class="form-group">
        <label for="name" class="form-label"> {{'cues.proyectos.nombre-adicional' | translate}} *</label>
        <input id="name" type="text" class="form-input anchosInputs" formControlName="name">
      </div>

    @if (!gantAditionalId) {
      <div class="form-group">
        <label for="type" class="form-label">
            {{'cues.proyectos.selec-tipo' | translate}} *
        </label>
        <select id="type" class="contentSelect anchosInputs" formControlName="type" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          <option value="text"> <span [matTooltip]="'cues.proyectos.adicional-1-etiqueta' | translate">
              {{'cues.proyectos.adicional-1' | translate}}</span> </option>
          <option value="file" [matTooltip]="'cues.proyectos.adicional-3-etiqueta' | translate">
            {{'cues.proyectos.adicional-3' | translate}} </option>
        </select>
      </div>
    }
    </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formAdit.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationAditional()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>